import { jsx as _jsx } from "react/jsx-runtime";
import Error24 from '@carbon/icons-react/es/error/24';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import merge from 'lodash/merge';
import { LANGUAGE_SELECT } from 'constant/constant';
import { getTranslationCache } from 'utils/translation-loader';
import { defaultModalProps, ModalBase } from './modal';
import * as styles from './modal.module.css';
const defaultMethodProps = {
    className: styles.modal_method,
    icon: /*#__PURE__*/ _jsx(FontAwesomeIcon, {
        icon: faCircleExclamation,
        fontSize: "16px",
        style: {
            marginBottom: '7px',
            marginRight: 'var(--spacing-01)'
        }
    }),
    zIndex: Number(styles.zIndex)
};
const defaultErrorModalProps = {
    className: styles.modal_method,
    icon: /*#__PURE__*/ _jsx(Error24, {}),
    zIndex: Number(styles.zIndex)
};
export const confirm = (props = {})=>{
    const locale = localStorage.getItem(LANGUAGE_SELECT);
    const translations = locale ? getTranslationCache().get(locale) : null;
    const modalProps = {
        ...props,
        // `merge` overwrites (rather than combines) plain string props like
        // `className` — a caller-supplied `className` would otherwise silently
        // drop `defaultMethodProps.className` (`modal_method`), which is what
        // scopes the footer-button flex/alignment CSS in modal.module.css. Concat
        // explicitly so callers can add their own class without losing it.
        className: [
            defaultMethodProps.className,
            props.className
        ].filter(Boolean).join(' '),
        okText: /*#__PURE__*/ _jsx("span", {
            "data-cy": `modal.confirm.${props.okText || 'Ok'}`,
            children: props.okText ? props.okText : (translations === null || translations === void 0 ? void 0 : translations.ok) || 'Ok'
        }),
        cancelText: /*#__PURE__*/ _jsx("span", {
            "data-cy": `modal.cancel.${props.cancelText || 'Cancel'}`,
            children: props.cancelText ? props.cancelText : (translations === null || translations === void 0 ? void 0 : translations.cancel) || 'Cancel'
        })
    };
    const CustomModal = props.CustomModal || ModalBase;
    return CustomModal.confirm(merge({}, defaultModalProps, defaultMethodProps, modalProps));
};
export const error = (props = {})=>ModalBase.error(merge({}, defaultModalProps, defaultErrorModalProps, {
        ...props,
        className: [
            defaultErrorModalProps.className,
            props.className
        ].filter(Boolean).join(' ')
    }));
